module.exports = __webpack_public_path__ + "static/media/editea_plugin_host_url_magento2.55f51fbe.png";